var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.16,10.6s-.14-1,.76-1,.75,1,.75,1v9S15.37,22,17,22s1.33-2.4,1.33-2.4V7.77s.14-2.9-2.46-2.9-2.45,2.91-2.45,2.91V21.07s-.33,4.58,3.61,4.58,3.56-4.58,3.56-4.58V11s-.09-1,.75-1,.76,1,.76,1V22.56A4.84,4.84,0,0,1,17,27.14a4.84,4.84,0,0,1-5.1-4.58V6.64a3.64,3.64,0,0,1,4-3.35,3.64,3.64,0,0,1,4,3.35V20.33s.32,3.18-2.86,3.18-2.8-3.18-2.8-3.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.09e5936f.svg";
export { ForwardRef as ReactComponent };